module.exports = __webpack_public_path__ + "static/media/froze.95cf9e52.svg";